import { ROLE_IDS } from '@/auth/utils'

const pageName = { singular: 'Posisi', plural: 'Posisi' }

export default [
  {
    path: '/positions',
    name: 'positions',
    component: () => import('@/views/pages/position/List.vue'),
    meta: {
      name: pageName,
      resource: 'Position',
      action: 'manage',
      allowedRoles: [ROLE_IDS.ADMIN],
      breadcrumb: [
        {
          text: pageName.plural,
          active: true,
        },
      ],
    },
  },
]
